import React from 'react';
import { Flex, TextV2 as Text } from '@withjoy/joykit';
import { FilterFacet } from './FilterFacet';
import { StyledCheckboxV2 } from '../components';
import { StarRating } from '@shared/components';
import { useTranslation } from '@shared/core';

interface StarRatingFacetProps {
  starRatings: number[];
  selectedRatings: number[];
  starRatingCounts: Record<number, number>;
  onRatingToggle: (rating: number) => void;
  title: string;
  description: string;
  checkboxOverrides?: Record<string, unknown>;
}

export const StarRatingFacet: React.FC<StarRatingFacetProps> = ({ starRatings, selectedRatings, starRatingCounts, onRatingToggle, title, description, checkboxOverrides }) => {
  const { t } = useTranslation('accommodationsConsole');
  const filterPanelTrans = t('filterPanel');

  return (
    <FilterFacet
      title={title}
      description={description}
    >
      <Flex
        flexDirection="column"
        gap={5}
      >
        {starRatings.map(rating => (
          <StyledCheckboxV2
            key={rating}
            isChecked={selectedRatings?.includes(rating)}
            onChange={() => onRatingToggle(rating)}
            id={`star-rating-${rating}`}
            overrides={checkboxOverrides}
            isDisabled={!starRatingCounts[rating]}
          >
            <Flex
              alignItems="center"
              gap={2}
            >
              <Text
                typographyVariant="body2"
                color="mono14"
              >
                {filterPanelTrans.starRating.starWithCount({ star: rating })}
              </Text>
              <StarRating
                rating={rating}
                hideNonFilledStars
                id={`star-rating-${rating}`}
              />
            </Flex>
          </StyledCheckboxV2>
        ))}
      </Flex>
    </FilterFacet>
  );
};
